import ru from '../locales/ru.json';
import en from '../locales/en.json';
import de from '../locales/de.json';

export default {
  ru,
  en,
  de,
};
